import React from 'react';
import { LoadingBase } from './LoadingBase';

const LoadingPage = ({ className = '', ...props }) => (
  <LoadingBase className={`loading--page ${className}`} {...props} />
);

export { LoadingPage };



// WEBPACK FOOTER //
// ./src/components/loading/LoadingPage.js